import { app } from '../../../../../app';
import { Controller } from './edit-remote-app.controller';

app.component('companyManageApplicationRemoteAppEdit', {
    bindings: {
        appId: '<',
        companyId: '<',
        groups: '<',
        remoteApp: '<',
        remoteApps: '=',
        groupsModel: '<',
    },
    controller: Controller,
    templateUrl: require('./edit-remote-app.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remote-app-access/edit/edit-remote-app.component.js